module cr.events
{
    class TrackingController
    {
        static $inject = ['eventView', 'TrackingService', '$scope', '$stateParams', '$modal','gpsConfiguration','$interval'];

// This example adds a search box to a map, using the Google Place Autocomplete
        // feature. People can enter geographical searches. The search box will return a
        // pick list containing a mix of places and predicted search terms.

        // This example requires the Places library. Include the libraries=places
        // parameter when you first load the API. For example:
        // <script src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places">

        SetMapType=type=>
        {
            this.map.setMapTypeId(type);
        }

        markers:any={};
        enabledTrackers:any={};
        lastPosition:any={};


        // Add icon.
        PlaceMarkerIcon(key,name, lat, lng, icon,label)
        {
            var location = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));

            // Get or create marker.
            var marker = this.markers[key];
            if (marker == undefined) {

                if (!angular.isDefined(icon)) icon='s16';

                var image = {
                    url: 'https://chronorace.blob.core.windows.net/webresources/img/icons/'+icon+'.png',
                    // This marker is 20 pixels wide by 32 pixels high.
                    size: new google.maps.Size(62, 39),
                    // The origin for this image is (0, 0).
                    origin: new google.maps.Point(0, 0),
                    // The anchor for this image is the base of the flagpole at (0, 32).
                    anchor: new google.maps.Point(31, 39)
                };


                marker = new MarkerWithLabel({
                    position: location,
                    map: this.map,
                    icon:image,
                    labelContent: label,
                    //label:info,
                    labelAnchor: new google.maps.Point(30, 37),
                    labelClass: "labelscustom", // the CSS class for the label
                    labelStyle: { opacity: 1 }
                });


                var infoWindow = new google.maps.InfoWindow();
                //marker.window=infoWindow;

                google.maps.event.addListener(marker, 'click',  ()=> {
                    var lst=this.lastPosition[key];
                    var html = '<strong>' + name + '</strong><br />' + (lst!=null?lst.DisplayTime:"");

                    infoWindow.setContent(html);
                    infoWindow.open(this.map, marker);
                });

                this.markers[key] = marker;
            } else {
                marker.setPosition(location);
            }

            if (this.enabledTrackers[key] && marker.map==null) marker.setMap(this.map);
            else if (!this.enabledTrackers[key] && marker.map!=null) marker.setMap(null);
        }

        // Add marker.
        PlaceMarker(key, name, lat, lng, info,label)
        {
            var location = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));

            // Get or create marker.
            var marker = this.markers[key];
            if (marker == undefined) {
                marker = new MarkerWithLabel({
                    position: location,
                    map: this.map,
                    //label:info,
                    labelContent: label,
                    labelAnchor: new google.maps.Point(20, -10),
                    labelClass: "labels", // the CSS class for the label
                    labelStyle: { opacity: 1 }
                });

                var infoWindow = new google.maps.InfoWindow();
                //marker.window=infoWindow;

                google.maps.event.addListener(marker, 'click',  ()=> {
                    var lst=this.lastPosition[key];
                    var html = '<strong>' + name + '</strong><br />' + (lst!=null?lst.DisplayTime:"");

                    infoWindow.setContent(html);
                    infoWindow.open(this.map, marker);
                });

                this.markers[key] = marker;
            } else {
                marker.setPosition(location);
            }

            if (this.enabledTrackers[key] && marker.map==null) marker.setMap(this.map);
            else if (!this.enabledTrackers[key] && marker.map!=null) marker.setMap(null);
        }


        poly:any=null;

        CenterOnMarker(marker)
        {
            console.log("center on "+angular.toJson(marker));
            var lst=this.lastPosition[marker];
            if (lst==null) return;

            if (this.poly!=null) {
                this.poly.setMap(null);
                this.poly=null;
            }

            var center = new google.maps.LatLng(lst.Lat, lst.Lon);
            this.map.setCenter(center);



            this.trackingService.getLog(this.$stateParams["eventId"],marker).then(log=>{
               console.log("log: "+angular.toJson(log));


                var points:any=[];
                angular.forEach(log,point=>{
                    var toAdd=new google.maps.LatLng(point.Lat, point.Lon);
                    points.push(toAdd)
                });

                // Add line.
                this.poly = new google.maps.Polyline({
                    path: points,
                    strokeColor: "#00AA00",
                    strokeOpacity: .6,
                    map:this.map,
                    strokeWeight: 4 });

                this.poly.setMap(this.map);
            });
        }


        InitAutocomplete()
        {

            // Create the search box and link it to the UI element.
            var input = document.getElementById('places');
            var searchBox = new google.maps.places.SearchBox(input);

            console.log("map: "+this.map);

            //this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

            // Bias the SearchBox results towards current map's viewport.
            this.map.addListener('bounds_changed', () => {
                searchBox.setBounds(this.map.getBounds());
            });



            var markers = [];
            // Listen for the event fired when the user selects a prediction and retrieve
            // more details for that place.
            searchBox.addListener('places_changed', () => {
                var places = searchBox.getPlaces();

                if (places.length == 0) {
                    return;
                }

                // Clear out the old markers.
                markers.forEach(function(marker) {
                    marker.setMap(null);
                });
                markers = [];

                // For each place, get the icon, name and location.
                var bounds = new google.maps.LatLngBounds();
                places.forEach((place) => {
                    if (!place.geometry) {
                        console.log("Returned place contains no geometry");
                        return;
                    }
                    var icon = {
                        url: place.icon,
                        size: new google.maps.Size(71, 71),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(17, 34),
                        scaledSize: new google.maps.Size(25, 25)
                    };

                    // Create a marker for each place.
                    markers.push(new google.maps.Marker({
                        map: this.map,
                        icon: icon,
                        title: place.name,
                        position: place.geometry.location
                    }));

                    if (place.geometry.viewport) {
                        // Only geocodes have viewport.
                        bounds.union(place.geometry.viewport);
                    } else {
                        bounds.extend(place.geometry.location);
                    }
                });
                this.map.fitBounds(bounds);
            });

            angular.forEach(this.gpsConfiguration.Trackers,(v,k)=>{
                this.enabledTrackers[k]=true;
            });
            //console.log(angular.toJson("enabled: "+angular.toJson(this.enabledTrackers)));
        }

        map:any;
        infowindow:any;
        geocoder:any;

        AddTrack(color:any,trackData:any)
        {
            var points:any=[];

            console.log("Add track: ");

            var bounds = new google.maps.LatLngBounds();
            //After that, you can get the center with:

            //bounds.getCenter();
            //Or alternatively, you can call map.fitBounds() directly, which will center the map around the center of the bounds and adjust the zoom, so that the whole bounds will fit exactly into the view port.
            //map.fitBounds(bounds);

            angular.forEach(trackData,point=>{
                var toAdd=new google.maps.LatLng(point.Lat, point.Lon);
                points.push(toAdd)
                bounds.extend(toAdd);
            });

            // Add line.
            var poly = new google.maps.Polyline({
                path: points,
                strokeColor: color,
                strokeOpacity: .7,
                strokeWeight: 4 });

            poly.setMap(this.map);
            this.map.fitBounds(bounds);

        }

        InitMap()
        {
            var mC=document.getElementById('map');
            console.log("map element: "+mC);

            this.geocoder = new google.maps.Geocoder;
            this.infowindow = new google.maps.InfoWindow;

            var center = {lat: parseFloat(this.gpsConfiguration.TrackingOriginLatitude), lng: parseFloat(this.gpsConfiguration.TrackingOriginLongitude)};
            this.map = new google.maps.Map(document.getElementById('map'), {
                zoom: 4,
                mapTypeControl: false,
                center: center,
                mapTypeId: 'hybrid'
            });

            /*var marker = new google.maps.Marker({
                position: uluru,
                map: this.map
            });*/

            this.InitAutocomplete();

            /*var ctaLayer = new google.maps.KmlLayer({
                url: 'https://crdev.blob.core.windows.net/tracks/1186437470963641/spa.kml',
                map: this.map
            });*/

            angular.forEach(this.gpsConfiguration.Tracks,track=>{
                angular.forEach(track.Files,file=>{
                    console.log("load track: "+file);
                    if (file.endsWith(".kml"))
                    {
                        /*markerUrl =  'https://crdev.blob.core.windows.net/tracks/<%= RegContext.Evenement.Id %>/'+file+'?xx=123';
                        console.log("marker url: " + markerUrl);

                        var ctaLayer = new google.maps.KmlLayer({
                            url: markerUrl,
                            map: trackerMap
                        });*/
                    }
                    else
                    {
                        this.trackingService.getTrack(this.$stateParams["eventId"],file).then(data=>this.AddTrack(track.Color,data));

                        // Log.
                        /*console.log('Processing file: ' + file + "(" + color.Color + ")");
                        console.log('  > Url: ' + markerUrl);

                        // Load.
                        AddTrack(markerUrl, color.Color);*/
                    }

                })
            });

            this.InitInterval();

            console.log("init map");
        }

        GetIcon=(tracker)=>
        {
            var icon=tracker.Marker;
            if (!angular.isDefined(icon)) icon= "s16";
            return 'https://chronorace.blob.core.windows.net/webresources/img/icons/'+icon+'.png';

        }

        DrawTrackers()
        {

            angular.forEach(this.lastPosition,(tk,k)=>{
                var tkCfg=this.gpsConfiguration.Trackers[tk.DeviceId];
                //this.PlaceMarker(tk.DeviceId,tk.DeviceId+' - '+tkCfg.DisplayName,tk.Lat,tk.Lon,tk.DisplayTime,tkCfg.DisplayName);
                this.PlaceMarkerIcon(tk.DeviceId,tk.DeviceId+' - '+tkCfg.DisplayName,tk.Lat,tk.Lon,tkCfg.Marker,tkCfg.Bib);
            });

        }

        RefreshTrackers()
        {
            this.trackingService.getPosition(this.$stateParams["eventId"]).then(tks=>{
                this.lastPosition=tks;
                this.DrawTrackers();
            });
        }

        InitInterval()
        {
            var timer = this.$interval(()=>
            {
                this.RefreshTrackers();
            },5000);

            this.$scope.$on('$destroy', () => {
                // Make sure that the interval is destroyed too
                this.$interval.cancel(timer);
            });

            this.RefreshTrackers();
        }

        constructor(private eventView, private trackingService, private $scope, private $stateParams, private $modal,private gpsConfiguration,private $interval)
        {
            setTimeout(()=>this.InitMap(),100);
        }
    }

    eventModule.controller('TrackingController', TrackingController);

}
